(() => {
  if (window.__evolveVariantSyncInstalled) return;
  window.__evolveVariantSyncInstalled = true;

  const selectedByProduct = new Map();

  const getPicker = (node) => node?.closest?.('variant-picker') || null;

  const getSelectedVariantId = (picker) => {
    if (!picker) return null;
    const selected = picker.querySelector(
      'fieldset input:checked[data-variant-id], select option:checked[data-variant-id], select option[selected][data-variant-id]'
    );
    return selected?.dataset?.variantId || null;
  };

  const syncProductForms = (picker, variantId) => {
    if (!picker || !variantId) return;
    const productId = picker.dataset.productId;
    if (!productId) return;

    const matchingForms = Array.from(document.querySelectorAll('product-form-component')).filter(
      (formComponent) => formComponent.dataset.productId === productId
    );

    for (const formComponent of matchingForms) {
      const input = formComponent.querySelector('input[name="id"]');
      if (input instanceof HTMLInputElement) {
        input.value = variantId;
        input.setAttribute('value', variantId);
      }
    }
  };

  const preservePickerSelection = (picker, variantId) => {
    if (!picker || !variantId) return;
    const escapedId = window.CSS?.escape ? CSS.escape(variantId) : variantId;
    const match = picker.querySelector(`[data-variant-id="${escapedId}"]`);
    if (!match) return;

    if (match instanceof HTMLInputElement) {
      const group = match.closest('fieldset');
      if (group) {
        for (const input of group.querySelectorAll('input[type="radio"]')) {
          input.checked = input === match;
          input.dataset.currentChecked = input === match ? 'true' : 'false';
        }
      } else {
        match.checked = true;
      }
    } else if (match instanceof HTMLOptionElement) {
      const select = match.parentElement;
      if (select instanceof HTMLSelectElement) {
        select.value = match.value;
        for (const option of select.options) {
          if (option === match) option.setAttribute('selected', 'selected');
          else option.removeAttribute('selected');
        }
      }
    }
  };

  const findPickerForProduct = (productId, context) => {
    if (!productId) return null;

    const localPicker = context?.querySelector?.(`variant-picker[data-product-id="${productId}"]`);
    if (localPicker) return localPicker;

    return Array.from(document.querySelectorAll('variant-picker')).find(
      (picker) => picker.dataset.productId === productId
    ) || null;
  };

  document.addEventListener(
    'change',
    (event) => {
      const picker = getPicker(event.target);
      if (!picker) return;

      const selectedOption =
        event.target instanceof HTMLSelectElement
          ? event.target.options[event.target.selectedIndex]
          : event.target;

      const variantId = selectedOption?.dataset?.variantId;
      const productId = picker.dataset.productId;
      if (!variantId || !productId) return;

      selectedByProduct.set(productId, variantId);
      syncProductForms(picker, variantId);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productForm = form.closest('product-form-component');
      if (!productForm) return;

      const productId = productForm.dataset.productId;
      const context = productForm.closest('.shopify-section, dialog, product-card') || document;
      const picker = findPickerForProduct(productId, context);
      const variantId = selectedByProduct.get(productId) || getSelectedVariantId(picker);
      if (!variantId) return;

      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput instanceof HTMLInputElement) {
        variantInput.value = variantId;
        variantInput.setAttribute('value', variantId);
      }

      if (picker) syncProductForms(picker, variantId);
    },
    true
  );

  document.addEventListener('variant:update', (event) => {
    const picker = getPicker(event.target);
    if (!picker) return;

    const productId = picker.dataset.productId;
    if (!productId) return;

    const variantId = selectedByProduct.get(productId);
    if (!variantId) return;

    preservePickerSelection(picker, variantId);
    syncProductForms(picker, variantId);
  });
})();
